export const GROUPS = {
  COMPANY_ADMIN: 'Company admin',
  COMPANY_EMPLOYEE: 'Company employee',
};
